import {
	clearSalesHeaderFilters,
	confirmSalesMonitor,
	getConfigVoucher,
	getFilterBranches,
	getFilterConditionSale,
	getFilterSellers,
	getFilterTransport,
	getOptionsFilterAffected,
	getOrdenCbtCab,
	getOrderDirOptions,
	getSalesMonitorItems,
	getZones,
	setSalesHeaderFilters
} from 'actions'
import NotificationMessage from 'components/common/notificationMessage'
import { P_SALES_MONITOR } from 'constants/ConfigProcessNames'
import { addPrevValidations } from 'lib/AxiosInterceptors'
import { getFiltersData } from 'lib/Utils'
import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import FormFilters from './FormFilters'
import SalesMonitorTable from './SalesMonitorTable'
import {
	ISalesMonitorComponentProps,
	ISalesMonitorComponentState
} from './SalesMonitorType'

class SalesMonitorComponent extends Component<
	ISalesMonitorComponentProps,
	ISalesMonitorComponentState
> {
	constructor(props: ISalesMonitorComponentProps) {
		super(props)
		this.state = {
			messageError: '',
			showError: false,
			typeError: 'danger',
			filtersForm: {
				idOperacion: props.idOperacion,
				page_number: 1,
				page_size: 10,
				fec_desde: '',
				fec_hasta: '',
				suc_emp: '',
				vendedor: '',
				transporte: '',
				cond_vta: '',
				orden: 'F',
				sentido: 'D',
				rsoc: '',
				cant_ini: 0,
				cant_fin: 0,
				zona: ''
			},
			tableFiltersReset: false,
			showFilters: true
		}

		addPrevValidations((e: any) => {
			if (e.request.responseURL.includes('/vta_MonitorPreparacion')) {
				return true
			}
			return false
		})
	}

	componentDidMount = () => {
		const { filtersForm } = this.state
		this.props.componentRef(this)
		this.props.getSalesMonitorItems({ ...filtersForm })
		this.props.getFilterBranches()
		this.props.getOrderDirOptions()
		this.props.getFilterSellers()
		this.props.getFilterTransport()
		this.props.getFilterConditionSale()
		this.props.getOrdenCbtCab()
		this.props.getOptionsFilterAffected()
		this.props.getZones()
	}

	componentDidUpdate = (
		prevProps: ISalesMonitorComponentProps,
		prevState: ISalesMonitorComponentState
	) => {
		const { salesMonitorError, barCodeResponse, idOperacion } = this.props

		const { filtersForm } = this.state

		if (
			!_.isEqual(barCodeResponse, prevProps.barCodeResponse && barCodeResponse)
		) {
			const params = {
				...filtersForm,
				page_number: 1,
				page_size: 10,
				idOperacion
			}
			this.props.getSalesMonitorItems({ ...params })
		}

		if (
			salesMonitorError !== prevProps.salesMonitorError &&
			salesMonitorError
		) {
			const { message } = salesMonitorError
			const showError = true

			this.setState({
				showError,
				messageError: message
			})
		}

		if (filtersForm !== prevState.filtersForm) {
			this.setState({ tableFiltersReset: false })
			this.props.getSalesMonitorItems({ ...filtersForm })
		}
	}

	/**
	 * to confirm the form and call CallBack
	 */
	handleConfirmForm = () => {
		const { idOperacion, callBackReturn } = this.props

		this.props.confirmSalesMonitor({
			values: { idOperacion },
			callBackReturn
		})
	}

	/**
	 * call search api with filters params.
	 * @param filters
	 */
	handleFilterSearch = (filters: any) => {
		const { idOperacion } = this.props
		const { filtersForm } = this.state

		const params = {
			...filtersForm,
			page_size: 10,
			page_number: 1,
			idOperacion
		}

		this.setState({ filtersForm: { ...params, ...filters } })
	}

	/**
	 * to show and hide the filters
	 */
	toggleFilters = () => {
		this.setState((state) => ({
			showFilters: !state.showFilters
		}))
	}

	/**
	 * close notification error
	 */
	handleCloseErrorNotification = () => {
		this.setState({ showError: false })
	}

	handleClearFilters = () => {
		const { idOperacion } = this.props

		this.setState({
			filtersForm: {
				idOperacion,
				page_number: 1,
				page_size: 10,
				fec_desde: '',
				fec_hasta: '',
				suc_emp: '',
				vendedor: '',
				transporte: '',
				cond_vta: '',
				orden: 'F',
				sentido: 'D',
				rsoc: '',
				cant_ini: 0,
				cant_fin: 0,
				zona: ''
			},
			tableFiltersReset: true
		})
	}

	render() {
		const { config, idOperacion } = this.props
		const { showError, messageError, typeError, filtersForm, showFilters } =
			this.state

		const fieldsFilter = config
			? getFiltersData(config.campos, { agrupador: 'formulario' })
			: []

		const fieldsTable = config
			? getFiltersData(config.campos, { agrupador: 'grilla' })
			: []

		const notificationsProps = {
			showError,
			errorMessage: messageError,
			type: typeError,
			handleCloseError: this.handleCloseErrorNotification
		}

		return (
			<Col className={`col-12`}>
				{!_.isEmpty(fieldsFilter) && (
					<FormFilters
						initialState={filtersForm}
						fields={fieldsFilter}
						handleFilterSearch={this.handleFilterSearch}
						idOperacion={idOperacion}
						clearFilters={this.handleClearFilters}
						showFilters={showFilters}
						toggleFilters={this.toggleFilters}
					/>
				)}
				<NotificationMessage {...notificationsProps} />
				<SalesMonitorTable
					fields={fieldsTable}
					idOperacion={idOperacion}
					formFilters={filtersForm}
				/>
			</Col>
		)
	}
}

const mapStateToProps = ({ voucher, auth, budgetItems, salesMonitor }: any) => {
	const config = voucher.config ? voucher.config[P_SALES_MONITOR] : null
	const { barCodeResponse, salesMonitorError } = salesMonitor
	const { authUser } = auth
	return {
		config,
		authUser,
		barCodeResponse,
		salesMonitorError
	}
}

const mapDispatchToProps = {
	getConfigVoucher,
	getSalesMonitorItems,
	getFilterBranches,
	getOrderDirOptions,
	getFilterSellers,
	getFilterTransport,
	getFilterConditionSale,
	getOrdenCbtCab,
	confirmSalesMonitor,
	getOptionsFilterAffected,
	setSalesHeaderFilters,
	clearSalesHeaderFilters,
	getZones
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(SalesMonitorComponent))
